export enum MessageType {
  QU = 'queueUpdate',
  WQ = 'waitingQueue',
  WS = 'waitingStart',
  CI = 'chatInit',
  CC = 'chatConnect',
  RC = 'robotConnect',
  CD = 'chatDisconnect',
  ET = 'eventTerminate',
  SB = 'sensitiveBlocked',
  SW = 'sensitiveWarning',
  EMAIL_SIDE = 'msg_email_side',
  ER = 'eventReconnect',
  TEXT = 'text',
  BINARY = 'binary',
  RECOM = 'recommendations',
  NAV = 'navigation',
  GC = 'gradeChat',
  EA = 'eventAgent',
  MQ = 'matchQuestions', // 问题卡片的回答（应只有机器人会发）
}

export enum QueueType {
  SERVING = 'SERVING',
  WAITING = 'WAITING',
}

export enum ActionType {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
}

export enum NavType {
  TRANSFER_AGENT = 0,
  QUESTION = 1,
  LINK = 2,
}

export enum ChannelType {
  WEBSITE = 1,
  TELEGRAM = 2,
}

export enum SenderType {
  AGENT = 'agent',
  CUSTOM = 'custom',
  SYS = 'system',
  ROBOT = 'robot',
}

export enum ChatStatus {
  WAITING,
  ROBOT,
  AGENT,
  TERMINATION,
}

export enum SenderIdType {
  SYS = '-1',
  TO_AGENT = '-2',
  TO_CUSTOM = '-3',
}
